
import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | null>(null)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    
    mql.addEventListener("change", onChange)
    onChange() // Set initial value immediately
    
    return () => mql.removeEventListener("change", onChange)
  }, [])

  // During SSR or initial render, return false to prevent layout shift
  return isMobile === null ? false : isMobile
}
